import { BaseService } from '../../Global/services/baseService';
import { AuthService } from '../services/authServices';
import { globalConfig } from '../../../config/globalConfig';
import { api } from '../../../config/api';
import { forOwn } from 'lodash';

export class AuthActions {
    static DEFAULT_URL = `${globalConfig.api}/auth-service/`;

    static apiResource(dispatch, url, method = BaseService.GET_METHOD, params = {}, config = {}, withoutSpinner = false, withoutToast = false) {
        let _params = method === BaseService.GET_METHOD ? { params: params } : params;
        return BaseService.doPromise(dispatch, api[method](`${AuthActions.DEFAULT_URL}${url}`, _params, config), withoutSpinner, withoutToast);
    }

    static apiRefreshResource(dispatch, url, method = BaseService.GET_METHOD, params = {}, config = {}, withoutSpinner = false, withoutToast = false) {
        let _params = method === BaseService.GET_METHOD ? { params: params } : params;
        return BaseService.doPromise(dispatch, api[method](`${globalConfig.api}/${url}`, _params, config), withoutSpinner, withoutToast);
    }
}

export function getOAuthParameters(captcha = null) {
    let _params = { scope: 'web' };
    if (captcha) {
        _params['captcha-token'] = captcha;
    }
    return _params;
}

/**
 * Авторизация пользователя по паре логин / пароль
 * @param {String} login
 * @param {String} password
 * @param {Boolean} refresh
 * @param {String | null} captcha
 */
export function token(login, password, refresh = false, captcha = null) {
    let _params = getOAuthParameters(captcha);
    if (!refresh) {
        _params.grant_type = 'password';
        _params.username   = login;
        _params.password   = password;
    }
    else {
        _params.grant_type = 'refresh_token';
        _params.refresh_token = AuthService.getUserInfo().refresh_token;
    }
    const config = {
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    };
    let str      = [];
    forOwn(_params, (value, field) =>
        str.push(encodeURIComponent(field) + '=' + encodeURIComponent(value)),
    );
    return AuthActions[refresh ? 'apiRefreshResource' : 'apiResource'](null, refresh ? 'refresh-token' : 'oauth/token', BaseService.POST_METHOD, str.join('&'), config, false, true)
        .then(res => {
            if (res) AuthService.setUserInfo(res);
            return res;
        });
}

/**
 * Whoami
 */
export function whoami() {
    return BaseService.doPromise(
        null,
        api[BaseService.GET_METHOD](
            `${globalConfig.api}/auth-service/external/users/whoami/with-cookie`,
        ),
        {},
        true,
    )
        .then(res => {
            if (res) AuthService.setUserInfo(res);
            return res;
        });
}

/**
 * Действие выхода из системы
 */
export function logOut() {
    return AuthActions.apiResource(null, 'auth/logout', BaseService.GET_METHOD, {}, {}, true, true);
}
